import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageUserService } from "../../../commons";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { IUserDTO } from "../../../api-services/manage-user-service";

export interface IUserAddOption {
  userData: IUserDTO;
}

interface IUserAdd {
  userAddResponseStatus: StatusEnum;
}

const initialState: IUserAdd = {
  userAddResponseStatus: StatusEnum.Idle,
};

export const userAdd = createAsyncThunk(
  "manage/userAdd",
  async (options: IUserAddOption, thunkAPI) => {
    try {
      const userAddResponse = await manageUserService.addUser(options.userData);
      return userAddResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageUserAddSlice = createSlice({
  name: "userAdd",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(userAdd.pending, (state) => {
        state.userAddResponseStatus = StatusEnum.Loading;
      })
      .addCase(userAdd.fulfilled, (state) => {
        state.userAddResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(userAdd.rejected, (state) => {
        state.userAddResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageUserAddSlice.reducer;
